<template>
  <div class="home" v-loading="loading">
    <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <swiper-slide class="swiper-slide slide-one">
        <div class="page">
          <h3>{{ $t('title.companyName') }}</h3>
<!--          <p>Yida Stock</p>-->
        </div>
        <p class="slogan">{{ $t('title.slogan') }}</p>
      </swiper-slide>
      <swiper-slide class="swiper-slide slide-two">
        <div class="page">
          <h3>{{ $t('title.productCenter') }}</h3>
<!--          <p>Product Center</p>-->
        </div>
        <ul class="case-item">
          <li
            v-for="(item,index) in productList"
            :key="index"
            v-lazy:background-image="item.Img"
          >
            <router-link
              class="text-decoration"
              :to="{ name: 'productdetails', params: { id: item.Id }}"
            >
              <div class="case-item-hover">
                <p class="hover-title">{{item.Title}}</p>
                <div class="bottom"></div>
                <div class="more">
                  <span>MORE</span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </swiper-slide>
<!--      <swiper-slide class="swiper-slide slide-three">-->
<!--        <div class="page">-->
<!--          <h3>{{ $t('title.newsInformation') }}</h3>-->
<!--&lt;!&ndash;          <p>Latest News</p>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="news-content">-->
<!--          <div class="news-content-item" v-for="(news,i) in newsList" :key="i">-->
<!--            <div :style="'order: '+ (i%2==0 ? 1: 3)">-->
<!--              <router-link-->
<!--                class="text-decoration"-->
<!--                :to="{ name: 'newsdetails', params: { id: news.Id }}"-->
<!--              >-->
<!--                <div class="item-img" v-lazy:background-image="imgserver + news.Img"></div>-->
<!--              </router-link>-->
<!--            </div>-->
<!--            <div style="order: 2">-->
<!--              <el-divider>-->
<!--                <i class="el-icon-apple"></i>-->
<!--              </el-divider>-->
<!--            </div>-->
<!--            <div class="item-content" :style="'order: '+ (i%2==0 ? 3: 1)">-->
<!--              <h3>{{news.Title}}</h3>-->
<!--              <p>{{news.Content}}</p>-->
<!--              <span>{{news.CreateTime}}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </swiper-slide>-->
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "HelloWorld",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
        loading: false,
      productList: [],
      // newsList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      }
    };
  },
  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    if(this.$i18n.locale === 'zh-CN') {
      this.productList = [
        {"Id":41,"Img":require('@/assets/img/product-smoke-22.jpg'),"Title":"SUBOX","Content":"多达50000次抽吸。得益于创新的LC&HB（低功耗、高爆发）线圈，其中一个可以与四个普通网状线圈竞争，Subox提供了涡轮增压的蒸汽爆发，蒸汽云更密集，口味更令人满意。滑动气流轮来控制您的抽吸是更紧还是更松，以使糊状和电子烟的生产符合您的电子烟偏好。智能显示屏。功率输出可调。按下Type-C端口并保持3秒以切换电源模式。18口味可供选择。Subox是您轻松、美味、持久的电子烟之旅的终极选择！","Del":null,"CreateTime":"2023-11-30T11:14:20.92"},
        {"Id":42,"Img":require('@/assets/img/product-smoke-11.jpg'),"Title":"EVODBAR","Content":"推出全新的EvOD一次性电子烟盒套件，旨在通过创新的无线圈电子烟盒技术降低电子烟成本。与标准vape吊舱套件不同，EVOD的吊舱采用了全新的FOAM-TEC吊舱技术，无需在可更换的吊舱内安装内置线圈。当连接到EVOD设备上时，无线圈的foam.tec胶囊将电子液体从墨盒中推出，进入集成线圈中，提供最大的吸收率、无与伦比的风味，并降低了胶囊补充的成本。EVOD具有透明的电子储液罐和透明的接口，可以看到电子储液器何时耗尽。这使得您很容易知道何时需要切换豆荚架，以避免干燥撞击并保护线圈。当吊舱连接到线圈上时，FOAM-TEC吊舱将电子液体从药筒中推出，进入集成线圈，提供最大的吸收和无与伦比的风味，同时延长线圈的寿命。使用无线圈的豆荚填充物降低电子烟的成本。EvOD预充式豆荚可分为两包，价格是标准豆荚盒再充的一半。EVOD-Bar替换舱采用全新的泡沫技术，每个舱内不需要油。相反，泡沫将电子液体推入线圈，以获得最大的饱和度和令人难以置信的味道。D600线圈集成在设备中，而不是吊舱中，从而减少了吊舱重新填充的废物量。","Del":null,"CreateTime":"2023-11-30T14:35:52.737"},
        {"Id":40,"Img":require('@/assets/img/product-smoke-33.jpg'),"Title":"Eilbar Pro","Content":"显示屏指示器可让您实时了解电池寿命和电子液位。它允许您在抽吸时手动控制进气口。Elibar Pro具有0.6Ω的电阻和低NlC强度，专为MTL和DL电子烟而设计，最多可抽吸26000次。有10种口味可供选择。","Del":null,"CreateTime":"2023-11-30T11:12:30.45"},
        {"Id":39,"Img":require('@/assets/img/product-smoke-44.jpg'),"Title":"ARYMI","Content":"ELIBAR 10000。一次性10000次抽吸。同时支持MTL和DTL。网状线圈加热更快。提供更稳定的风味和蒸汽生产。大容量电池，电池寿命长。气流可调，支持MTL和DTL。","Del":null,"CreateTime":"2023-11-30T11:11:19.597"},
        {"Id":38,"Img":require('@/assets/img/product-smoke-55.jpg'),"Title":"Litdrop","Content":"正常模式25000次抽吸。脚部模式15000次抽吸。大屏幕幻影灯，按下按钮即可切换模式。推出首款水滴弧形屏幕，在相同容量范围内为您提供最精致的手感。符合人体工程学的设计确保了每次电子烟会话都是舒适和令人满意的。使用我们的智能屏幕体验新的互动水平。幻影流动光模式：令人着迷的色彩展示。极光模式：灵感来自北极光。火焰模式：模拟迷人的火焰闪烁。无论您喜欢更紧的抽气还是更通风的蒸汽。我们的设备都可以让您找到理想的设置，以获得最大的舒适度和满意度。正常模式：12W输出，蒸汽平稳稳定。BOOST MODE：24W输出，带来强烈而强大的体验。通过我们方便的电子液体和电池显示，您可以随时了解情况，轻松监控您的电子烟状态。告别漫长的充电时间。我们的设备具有方便的TYPE C充电功能，可确保快速充电，这样您就可以花更少的时间等待，花更多的时间享受您的电子烟。通过我们创新的双联技术，体验无与伦比的蒸汽生产和优势强度。向更丰富、更光滑的云朵问好，每一次吸气都会让你的味蕾着迷。用我们优质的电子液体品尝水果风味的真正精髓。我们的设备旨在复制最正宗的水果口味，提供丰富而美味的电子烟体验。","Del":null,"CreateTime":"2023-11-30T11:08:39.433"},
        {"Id":37,"Img":require('@/assets/img/product-smoke-66.jpg'),"Title":"Ubox / Upod","Content":"Ubox/Upod完全符合TPD标准（欧洲烟草专买产品认证）。与2mL/4mL吊舱兼容。更灵活的选择。Pod是可更换和可重新填充的。电源按钮。发光LED灯。气流可调。Type-C充电。","Del":null,"CreateTime":"2023-11-30T11:01:27.933"},
      ]
    } else if(this.$i18n.locale === 'zh-TW') {
      this.productList = [
        {"Id":41,"Img":require('@/assets/img/product-smoke-22.jpg'),"Title":"SUBOX","Content":"多達50000次抽吸。 得益於創新的LC&HB（低功耗、高爆發）線圈，其中一個可以與四個普通網狀線圈競爭，Subox提供了渦輪增壓的蒸汽爆發，蒸汽雲更密集，口味更令人滿意。 滑動氣流輪來控制您的抽吸是更緊還是更松，以使糊狀和電子烟的生產符合您的電子烟偏好。 智慧顯示幕。 功率輸出可調。 按下Type-C埠並保持3秒以切換電源模式。18口味可供選擇。 Subox是您輕鬆、美味、持久的電子烟之旅的終極選擇！","Del":null,"CreateTime":"2023-11-30T11:14:20.92"},
        {"Id":42,"Img":require('@/assets/img/product-smoke-11.jpg'),"Title":"EVODBAR","Content":"推出全新的EvOD一次性電子烟盒套件，旨在通過創新的無線圈電子烟盒科技降低電子烟成本。 與標準vape吊艙套件不同，EVOD的吊艙採用了全新的FOAM-TEC吊艙科技，無需在可更換的吊艙內安裝內寘線圈。 當連接到EVOD設備上時，無線圈的foam.tec膠囊將電子液體從墨水匣中推出，進入集成線圈中，提供最大的吸收率、無與倫比的風味，並降低了膠囊補充的成本。 EVOD具有透明的電子儲液罐和透明的介面，可以看到電子儲液器何時耗盡。 這使得您很容易知道何時需要切換豆莢架，以避免乾燥撞擊並保護線圈。 當吊艙連接到線圈上時，FOAM-TEC吊艙將電子液體從藥筒中推出，進入集成線圈，提供最大的吸收和無與倫比的風味，同時延長線圈的壽命。 使用無線圈的豆莢填充物降低電子烟的成本。 EvOD預充式豆莢可分為兩包，價格是標準豆莢盒再充的一半。 EVOD-Bar替換艙採用全新的泡沫科技，每個艙內不需要油。 相反，泡沫將電子液體推入線圈，以獲得最大的飽和度和令人難以置信的味道。 D600線圈集成在設備中，而不是吊艙中，從而减少了吊艙重新填充的廢物量。","Del":null,"CreateTime":"2023-11-30T14:35:52.737"},
        {"Id":40,"Img":require('@/assets/img/product-smoke-33.jpg'),"Title":"Eilbar Pro","Content":"顯示幕指示器可讓您實时瞭解電池壽命和電子液位。 它允許您在抽吸時手動控制進氣口。 Elibar Pro具有0.6Ω的電阻和低NlC强度，專為MTL和DL電子烟而設計，最多可抽吸26000次。有10種口味可供選擇。","Del":null,"CreateTime":"2023-11-30T11:12:30.45"},
        {"Id":39,"Img":require('@/assets/img/product-smoke-44.jpg'),"Title":"ARYMI","Content":"ELIBAR 10000。一次性10000次抽吸。 同時支持MTL和DTL。 網狀線圈加熱更快。 提供更穩定的風味和蒸汽生產。 大容量電池，電池壽命長。 氣流可調，支持MTL和DTL。","Del":null,"CreateTime":"2023-11-30T11:11:19.597"},
        {"Id":38,"Img":require('@/assets/img/product-smoke-55.jpg'),"Title":"Litdrop","Content":"正常模式25000次抽吸。脚部模式15000次抽吸。 大螢幕幻影燈，按下按鈕即可切換模式。 推出首款水滴弧形荧幕，在相同容量範圍內為您提供最精緻的手感。 符合人體工程學的設計確保了每次電子烟會話都是舒適和令人滿意的。 使用我們的智慧荧幕體驗新的互動水准。 幻影流動光模式：令人著迷的色彩展示。 極光模式：靈感來自北極光。 火焰模式：類比迷人的火焰閃爍。 無論您喜歡更緊的抽氣還是更通風的蒸汽。我們的設備都可以讓您找到理想的設定，以獲得最大的舒適度和滿意度。 正常模式：12W輸出，蒸汽平穩穩定。 BOOST MODE:24W輸出，帶來强烈而强大的體驗。 通過我們方便的電子液體和電池顯示，您可以隨時瞭解情况，輕鬆監控您的電子烟狀態。 告別漫長的充電時間。 我們的設備具有方便的TYPE C充電功能，可確保快速充電，這樣您就可以花更少的時間等待，花更多的時間享受您的電子烟。 通過我們創新的雙聯科技，體驗無與倫比的蒸汽生產和優勢强度。 向更豐富、更光滑的雲朵問好，每一次吸氣都會讓你的味蕾著迷。 用我們優質的電子液體品嘗水果風味的真正精髓。 我們的設備旨在複製最正宗的水果口味，提供豐富而美味的電子烟體驗。","Del":null,"CreateTime":"2023-11-30T11:08:39.433"},
        {"Id":37,"Img":require('@/assets/img/product-smoke-66.jpg'),"Title":"Ubox / Upod","Content":"Ubox/Upod完全符合TPD標準（歐洲烟草專買產品認證）。 與2mL/4mL吊艙相容。 更靈活的選擇。 Pod是可更換和可重新填充的。 電源按鈕。 發光LED燈。 氣流可調。 Type-C充電。","Del":null,"CreateTime":"2023-11-30T11:01:27.933"},
      ]
    } else if(this.$i18n.locale === 'en') {
      this.productList = [
        {"Id":41,"Img":require('@/assets/img/product-smoke-22.jpg'),"Title":"SUBOX","Content":"Up to 50000 puffs.Thanks to the innovative LC&HB(Low Consumption,High Burst) Coil, one of which can compete with fourordinary mesh coils, Subox delivers a turbo-chargedburst of vapor with denser vape cloud and greater tastesatisfactions.Sliding the airflow wheel to control whetheryou have a tighter or looser draw to make thetaste and vape production suit your vaping preferences.Intelligent Display Screen.Power Output Adjustable.Press the Type-C Port and hold for3 seconds to switch the power mode.18 Flavors to Choose.Subox is your ultimate choice foran easy, tasty and long-lastingvape journey!","Del":null,"CreateTime":"2023-11-30T11:14:20.92"},
        {"Id":42,"Img":require('@/assets/img/product-smoke-11.jpg'),"Title":"EVODBAR","Content":"INTRODUCING the all new EvOD disposable vape pod kit, designedto cut the costs of vaping with innovative coil-free pod technology.Unlike standard vape pod kits, the EVOD features podswith all new FOAM-TEC pod technology that removesthe need for in-built coils inside replaceable pods.When attached to the EVOD device, the coil-free foam.tec pods push the e-liquid out of the cartridge into theintegrated coil, providing maximum absorption,unbeatable flavourand slashing the cost of pod refills.EVODs feature a transparent e-liquid reservoir and clearmouthpiece to see when the e-liquid reservoir is running low.This makes it easy to know when you need to switch podshelping to avoid dry hits and protect the coil.When the pod is attached to the coil, the FOAM-TEC podspush the e-liquid outofthe cartridge into the integratedcoil, providing maximum absorption and unbeatableflavour whilst enhancing the longevity of the coil.Cut the cost of vaping with coil-free podrefills. EvOD pre-filled pods are available intwin-packs at half the cost of standard podkit refills.EVOD Bar replacement pods feature a brandnew foam technologythat doesn't require acoil in each pod. instead, the foam pushesthe e-liquid into the coil for maximumsaturation and incredible flavour.The D600 coil is integrated into thedevice rather than the pod, reducingthe amount of waste from pod refills.","Del":null,"CreateTime":"2023-11-30T14:35:52.737"},
        {"Id":40,"Img":require('@/assets/img/product-smoke-33.jpg'),"Title":"Eilbar Pro","Content":"The display screen indicator keeps you inthe loop about battery life and e-liquidlevels in real-time.It allow you to control the air intake manually when you take a puff.With 0.6Ω resistance and low NlC strength, Elibar Pro is designed for both MTL and DL vape, up to 26000 puffs.10 flavors to choose.","Del":null,"CreateTime":"2023-11-30T11:12:30.45"},
        {"Id":39,"Img":require('@/assets/img/product-smoke-44.jpg'),"Title":"ARYMI","Content":"ELIBAR 10000.Disposable 10000 Puffs.Support both MTL&DTL.Mesh Coil-Heat Faster.Deliver More Consistent Flavor and Vapor Production.High Capacity Battery,Long Battery Life.Airflow Adjustable Support Both MTL&DTL.","Del":null,"CreateTime":"2023-11-30T11:11:19.597"},
        {"Id":38,"Img":require('@/assets/img/product-smoke-55.jpg'),"Title":"Litdrop","Content":"normal mode 25000 puffs.boots mode 15000 puffs.Large-screen phantom lights,switch modes with a button press. Introducing the first water droplet arc screen, offering the most exquisite feel in your hand within the same capacity range. The ergonomic design ensures that every vape session is comfortable and satisfying.Experience a new level of interactivity with our intelligent screen.PHANTOM FLOWING LIGHT MODE: A mesmerizing display of colors.AURORA MODE: Inspired by the northern lights.FLAME MODE: Simulating the captivating flicker of flames.Whether you prefer a tighter draw or a more airy vape.our device allows you to find your ideal setting for maximum comfort and satisfaction.NORMAL MODE:12W output for a smooth and steady vape.BOOST MODE:24W output for an intense and powerful experience.Stay informed at all times with ourconvenient E-liquid and battery display, allowing you to monitor yourvaping status with ease.Say goodbye to long charging times. Ourdevice features convenient TYPE-Ccharging, ensuring rapid recharging soyou can spend less time waiting andmore time enjoying your vape.Experience unparalleled vapor production and favor intensity with our innovative dual coitechnology. Say hello to richer, smoother clouds that tantalize your taste buds with every inhale.Savor the true essence of fruit flavors with our premium e-liquids. Our deviceis designed to replicate the most authentic fruit tastes, providing a rich andflavorful vaping experience.","Del":null,"CreateTime":"2023-11-30T11:08:39.433"},
        {"Id":37,"Img":require('@/assets/img/product-smoke-66.jpg'),"Title":"Ubox / Upod","Content":"Ubox / Upod Fully TPD compliant(European Tobacco Purchase Product Certification).Compatible with 2mL/4mL pods.For more Flexible pick.Pod is replaceable and refillable.Power Button.Glowing LED Light.Airflow Adjustable.Type-C Charging.","Del":null,"CreateTime":"2023-11-30T11:01:27.933"},
      ]
    } else if(this.$i18n.locale === 'es') {
      this.productList = [
        {"Id":41,"Img":require('@/assets/img/product-smoke-22.jpg'),"Title":"SUBOX","Content":"Hasta 50.000 aspiraciones. Gracias a las innovadoras bobinas LC & HB (baja potencia, alta explosión), una de las cuales puede competir con cuatro bobinas de malla ordinarias, subox ofrece estallidos de vapor turboalimentados, con nubes de vapor más densas y sabores más satisfactorios. Deslice la rueda de flujo de aire para controlar si su succión es más apretada o más suelta para que la producción de pasta y cigarrillos electrónicos se ajuste a sus preferencias de cigarrillos electrónicos. Pantalla inteligente. La salida de potencia es ajustable. Presione el puerto tipo - C y mantenga durante 3 segundos para cambiar el modo de alimentación. 18 sabores para elegir. ¡¡ subox es la última opción para su viaje relajado, delicioso y duradero de cigarrillos electrónicos!","Del":null,"CreateTime":"2023-11-30T11:14:20.92"},
        {"Id":42,"Img":require('@/assets/img/product-smoke-11.jpg'),"Title":"EVODBAR","Content":"El lanzamiento del nuevo kit de cigarrillos electrónicos desechables evod tiene como objetivo reducir el costo de los cigarrillos electrónicos a través de la innovadora tecnología de cigarrillos electrónicos de círculo inalámbrico. A diferencia del kit estándar de cápsula vape, la cápsula de evod utiliza la nueva tecnología de cápsula Foam - tec, sin necesidad de instalar bobinas incorporadas en una cápsula reemplazable. Cuando se conecta al dispositivo evod, la cápsula foam.tec de la bobina inalámbrica expulsa el líquido electrónico del cartucho de tinta y entra en la bobina integrada, proporcionando la máxima absorción, sabores incomparables y reduciendo el costo de la reposición de la cápsula. El evod tiene un depósito electrónico transparente y una interfaz transparente para ver cuándo se agota el depósito electrónico. Esto hace que sea fácil saber cuándo es necesario cambiar el soporte de la vaina para evitar impactos secos y proteger la bobina. Cuando la cápsula está conectada a la bobina, la cápsula Foam - TEC expulsa el líquido electrónico del cartucho y entra en la bobina integrada, proporcionando la máxima absorción y un sabor incomparable, al tiempo que alarga la vida útil de la bobina. El uso de rellenos de vainas en círculos inalámbricos reduce el costo de los cigarrillos electrónicos. Las vainas precargadas de evod se pueden dividir en dos paquetes, y el precio es la mitad de la recarga de la Caja de vainas estándar. La cabina de reemplazo evod - Bar utiliza una nueva tecnología de espuma y no necesita aceite en cada cabina. En cambio, la espuma empuja el líquido electrónico hacia la bobina para obtener la máxima saturación y un sabor increíble. Las bobinas d600 están integradas en el equipo, no en la cápsula, lo que reduce la cantidad de residuos que se rellenan en la cápsula.","Del":null,"CreateTime":"2023-11-30T14:35:52.737"},
        {"Id":40,"Img":require('@/assets/img/product-smoke-33.jpg'),"Title":"Eilbar Pro","Content":"El indicador de pantalla le permite conocer la vida útil de la batería y el nivel de líquido electrónico en tiempo real. Le permite controlar manualmente la entrada de aire al aspirar. Elibar pro, con una resistencia de 0,6 Omega y una baja resistencia a nlc, está especialmente diseñado para los cigarrillos electrónicos MTL y dl y puede aspirar hasta 26.000 veces. hay 10 sabores para elegir.","Del":null,"CreateTime":"2023-11-30T11:12:30.45"},
        {"Id":39,"Img":require('@/assets/img/product-smoke-44.jpg'),"Title":"ARYMI","Content":"Elibar 10000. 10.000 aspiraciones desechables. Soporte tanto MTL como dtl. La bobina de malla se calienta más rápido. Proporciona un sabor más estable y una producción de vapor. Batería de gran capacidad, larga vida útil de la batería. El flujo de aire es ajustable y admite MTL y dtl.","Del":null,"CreateTime":"2023-11-30T11:11:19.597"},
        {"Id":38,"Img":require('@/assets/img/product-smoke-55.jpg'),"Title":"Litdrop","Content":"25.000 aspiraciones en modo normal. 15.000 en modo pie. Fantasma de pantalla grande, Presione el botón para cambiar el modo. Lanza la primera pantalla curvada de gotas de agua para proporcionarle la sensación más exquisita dentro del mismo rango de capacidad. El diseño ergonómico garantiza que cada sesión de cigarrillos electrónicos sea cómoda y satisfactoria. Use nuestra pantalla inteligente para experimentar nuevos niveles de interacción. Modo de flujo de luz fantasma: exhibición de color fascinante. Modo aurora: inspirado en la aurora boreal. Modo de llama: simula el encantador parpadeo de la llama. Ya sea que prefiera una extracción más apretada o un vapor más ventilado. nuestro equipo le permite encontrar la configuración ideal para obtener la máxima comodidad y satisfacción. Modo normal: salida de 12w, vapor estable y estable. Modo boost: salida de 24w, que aporta una experiencia fuerte y poderosa. A través de nuestra conveniente visualización de líquidos electrónicos y baterías, puede mantenerse al tanto de la situación y monitorear fácilmente su estado de cigarrillos electrónicos. Adiós al largo tiempo de carga. Nuestro dispositivo tiene una función de carga conveniente tipo C que garantiza una carga rápida, para que pueda pasar menos tiempo esperando y más tiempo disfrutando de sus cigarrillos electrónicos. A través de nuestra innovadora tecnología de doble unión, experimenta una producción de vapor incomparable y una intensidad superior. Saluda a las nubes más ricas y suaves, y cada inspiración fascinará tus papilas gustativas. Pruebe la verdadera esencia del sabor de la fruta con nuestros líquidos electrónicos de alta calidad. Nuestro dispositivo está diseñado para replicar los sabores frutales más auténticos y ofrecer una rica y deliciosa experiencia de cigarrillos electrónicos.","Del":null,"CreateTime":"2023-11-30T11:08:39.433"},
        {"Id":37,"Img":require('@/assets/img/product-smoke-66.jpg'),"Title":"Ubox / Upod","Content":"Ubox / upod cumple plenamente con los estándares tpd(certificación Europea de productos de compra exclusiva de tabaco). Compatible con la cápsula 2ml / 4ml. Opciones más flexibles. El pod es reemplazable y rellenable. Botón de encendido. Luces LED luminosas. El flujo de aire es ajustable. Se carga el tipo - C.","Del":null,"CreateTime":"2023-11-30T11:01:27.933"},
      ]
    }
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`)
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.productList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.loading = false;
    //     })
    //   );
  }
};
</script>

<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
.swiper-slide {
  font-size: 1.5rem; // 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 4.375rm; // 70px;
    //background: red;
    overflow: hidden;
    h3,
    p {
      font-size: 2.5rem; // 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 3.125rem; // 50px;
    color: #fff;
    padding: 1.875rem 0; // 30px 0;
  }
}
//经典案例
.case-item {
  width: 68.75rem; // 1100px;
  height: 31.25rem; // 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 1.875rem; // 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 20.625rem; // 330px;
    height: 15.625rem; // 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
@media (max-width: 500px) {
  .case-item {
    width: 80%;
    height: 31.25rem;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 1.875rem; // 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    li {
      width: 100%;
      height: 15.625rem; // 250px;
      list-style: none;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 5px;
      position: relative;
      overflow: hidden;

      &:hover {
        .case-item-hover {
          opacity: 1;
          transition: all 0.4s ease-in-out;
        }
      }
    }
  }
}


//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 3.125rem; // 50px;
    color: #fff;
    font-size: 1.125rem; // 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 1.25rem; // 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 3.75rem; // 60px;
    margin: 0 auto;
  }
  .more {
    width: 5.625rem; // 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 6.25rem; // 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 1.25rem; // 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url(../assets/img/home_top11.jpg) no-repeat center;
  background-size: cover;
}
.slide-two {
  background: url(../assets/img/home_do22.jpg) no-repeat center;
  background-size: cover;
}
//.slide-three {
//  background: url(../assets/img/home_anli.jpg) no-repeat center;
//  background-size: cover;
//}
//最新资讯
.news-content {
  width: 64rem; // 1240px;
  margin: 0 auto;
  margin-top: 2.5rem; // 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 25rem; // 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 22.5rem; // 360px;
      height: 14.375rem; // 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width:  1.25rem; // 20px;
        height: 1.25rem; // 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 22.5rem; // 360px;
      height: 14.375rem; // 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 1.375rem; // 22px;
        height: 1.875rem; // 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
</style>
